export default function ({},{cb}) {
    cb();
}